module.exports = __webpack_public_path__ + "static/media/drikkevann.16160ad8.png";